import { render, staticRenderFns } from "./loadingDotsDark.vue?vue&type=template&id=3b36c527&scoped=true"
import script from "./loadingDotsDark.vue?vue&type=script&lang=js"
export * from "./loadingDotsDark.vue?vue&type=script&lang=js"
import style0 from "./loadingDotsDark.vue?vue&type=style&index=0&id=3b36c527&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b36c527",
  null
  
)

export default component.exports